module.exports = __webpack_public_path__ + "static/media/last.6d0c0344.svg";